import styles from './FieldsAuth.module.css';
import fieldList from './FieldsAuthList';

const FieldsAuth = ({ index, value, setValue, visibility, setVisibility }) => {
    const field = fieldList[index];

    if (!field) return null;

    return (
        <div className={`${styles.fieldSection} ${field.type === 'password' ? styles.passwordMarge : ''}`}>
            <label htmlFor={index} className={styles.label}>
                {field.label} {index === 'passwordLogin' && <span className={styles.span}>Mot de passe oublié?</span>}
            </label>
 
            <div className={styles.passwordField}>
                <input
                    id={index}
                    className={styles.field}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    type={!visibility ? 'text' : field.type}
                    maxLength={field.maxLength}
                    minLength={field.minLength ?? undefined}
                    autoComplete="off"
                    placeholder={field.placeholder}
                />
                {field.type === 'password' && 
                <img
                    src={visibility ? '/Authentication/visibilityOffIcon.png' : '/Authentication/visibilityOnIcon.png'}
                    alt='Show'
                    className={styles.icon}
                    onClick={() => setVisibility(!visibility)}
                />
                }
            </div>
        </div>
    );
};

export default FieldsAuth;
